import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";

// Components
import GenericDialog from "./GenericDialog.Component";

// Classes
import Utility from "../../domain/classes/Utility";

// S3 Assets
import { DISKETTE_COLOURED } from "../../domain/utility/config";

// S3 Assets

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
		imgContainer: {
			height: 100,
			width: 100,
			margin: "auto",
			marginTop: theme.spacing(4),
			marginBottom: theme.spacing(4),
		},
		img: { height: "100%" },
	});

export interface SavedBookingDialogProps {
	onCancel: () => void;
	onContinue: () => void;
	open: boolean;
}

const SavedBookingDialog = React.forwardRef<
	HTMLDivElement,
	SavedBookingDialogProps & WithStyles<typeof styles>
>(({ classes, onCancel, onContinue, open }) => {
	return (
		<GenericDialog
			className={classes.root}
			open={open}
			title="We found a saved booking!"
			content={
				<React.Fragment>
					<div className={classes.imgContainer}>
						<img
							src={DISKETTE_COLOURED}
							className={classes.img}
							alt="Saved booking details."
						/>
					</div>
					<Typography variant="body1" align="center">
						Did you want to continue where you left off?
					</Typography>
				</React.Fragment>
			}
			actions={
				<React.Fragment>
					<Button onClick={onCancel}>No</Button>
					<Button
						onClick={onContinue}
						variant="contained"
						color="primary"
					>
						Yes
					</Button>
				</React.Fragment>
			}
		/>
	);
});

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("SavedBookingDialog"),
})(SavedBookingDialog);
